var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIconModal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145.468 38.0449C141.53 23.5518 126.457 8.47559 111.961 4.53809C103.072 2.32324 91.166 0.0410156 75 0C58.8398 0.0410156 46.9336 2.32324 38.0449 4.53809C23.5518 8.47559 8.47559 23.5488 4.53809 38.0449C2.32324 46.9307 0.0410156 58.8398 0 75C0.0410156 91.1631 2.32324 103.069 4.53809 111.958C8.47559 126.454 23.5518 141.527 38.0449 145.465C46.9336 147.68 58.8457 149.962 75.0029 150C91.1631 149.962 103.072 147.68 111.961 145.465C126.457 141.527 141.53 126.454 145.468 111.958C147.683 103.069 149.965 91.1572 150.003 75C149.965 58.8398 147.683 46.9336 145.468 38.0449Z",
    fill: "#FFE5E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75 25.1719C65.1448 25.1719 55.5109 28.0943 47.3167 33.5696C39.1224 39.0449 32.7358 46.8272 28.9646 55.9323C25.1933 65.0373 24.2067 75.0563 26.1295 84.7221C28.0524 94.3879 32.7984 103.266 39.7673 110.235C46.7361 117.203 55.6149 121.949 65.2808 123.871C74.9467 125.793 84.9656 124.806 94.0704 121.034C103.175 117.263 110.957 110.875 116.432 102.681C121.907 94.4863 124.829 84.8523 124.828 74.9971C124.827 61.7823 119.577 49.1091 110.233 39.7652C100.888 30.4212 88.2148 25.1719 75 25.1719Z",
    fill: "url(#paint0_linear_2455_19010)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.25 62.25H97.5V66.75H93V96C93 97.2427 91.9927 98.25 90.75 98.25H59.25C58.0074 98.25 57 97.2427 57 96V66.75H52.5V62.25H63.75V55.5C63.75 54.2574 64.7574 53.25 66 53.25H84C85.2427 53.25 86.25 54.2574 86.25 55.5V62.25ZM68.25 73.5V87H72.75V73.5H68.25ZM77.25 73.5V87H81.75V73.5H77.25ZM68.25 57.75V62.25H81.75V57.75H68.25Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2455_19010",
    x1: 110.235,
    y1: 110.232,
    x2: 39.7676,
    y2: 39.7646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF3739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#EF3739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8C8B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconModal);
export default __webpack_public_path__ + "static/media/delete-icon-modal.614bf7c5e7ba09d2d7ccb76298c53520.svg";
export { ForwardRef as ReactComponent };